export const LOAD_EXPENSE_TYPES = 'LOAD_EXPENSE_TYPES'
export const ADD_EXPENSE_TYPE = 'ADD_EXPENSE_TYPE'
export const UPDATE_EXPENSE_TYPE = 'UPDATE_EXPENSE_TYPE'
export const DELETE_EXPENSE_TYPE = 'DELETE_EXPENSE_TYPE'
export const LOAD_ALL_EXPENSE_TYPES = 'LOAD_ALL_EXPENSE_TYPES'
